<template>
	<div class="orderOperation">
		<el-drawer
			title="订单操作弹窗"
			custom-class="drawer-width"
			:with-header="false"
			:visible="popType != 0"
			:direction="direction"
			:before-close="handleCloseDetail"
			size="41%"
			v-if="secondPopType <= 0"
		>
			<div class="">
				<div class="title-drawer">
					<div class="title-text" v-if="user_code == 1 && popType == 12"> 订单支付 </div>
					<div class="title-text" v-else>{{ popTitle[popType] }}</div>
					<div class="close-title-drawer" @click="handleCloseDetail">
						<i class="el-icon-close"></i>
					</div>
				</div>
				<div v-if="popType == 14" class="apply-refund">
					<img src="../../src/assets/icon/Shape.png" alt="取消" /><span>
						<!-- 由于您的订单已进入设计中状态，如现取消，将可能承担一定设计费及微信支付手续费（第三方收
						取），请您知晓！ -->
						取消后，您的订单将重新排期交付， 请您知晓！
					</span>
				</div>
				<div
					class="pop-cont-box"
					v-if="
						popType == 1 ||
						popType == 2 ||
						popType == 3 ||
						popType == 7 ||
						popType == 8 ||
						popType == 12 ||
						popType == 13 ||
						popType == 14
					"
				>
					<h5>
						<p>{{ selectItem.order_pro_name }}</p>
						<p class="p2" v-if="popType == 14">
							支付订单金额：<span class="s1">￥{{ orderPrice.info.order_price }}</span>
						</p>
					</h5>
					<!-- 选择设计师 -->
					<template v-if="popType == 1 || popType == 7">
						<div class="select-designer-box">
							<div class="list-item-search designer-input">
								<el-input placeholder="请输入内容" v-model="designerSearchValue" clearable>
								</el-input>
								<el-button type="danger" @click="checkDesignerSearch">查询</el-button>
							</div>
							<el-table
								ref="designTable"
								:data="designList.list"
								tooltip-effect="dark"
								:header-cell-style="{
									backgroundColor: 'rgba(250, 250, 250, 0.4)',
								}"
								style="width: 100%"
								@select="selectDesingn"
							>
								<el-table-column type="selection" width="55"> </el-table-column>
								<el-table-column prop="real_name" label="姓名" width="420"> </el-table-column>
								<el-table-column prop="num" label="当前跟进订单数" show-overflow-tooltip>
								</el-table-column>
							</el-table>
						</div>
						<div class="order-list-page">
							<el-pagination
								background
								layout="prev, pager, next,jumper"
								:total="designList.total.total"
								:current-page="designList.total.current_page"
								:page-size="designPaging.limit"
								@current-change="designPagingChange"
							>
							</el-pagination>
						</div>
					</template>

					<!-- 订单报价 支付报价 -->
					<template v-if="popType == 3 || popType == 12">
						<div class="order-offer-box">
							<p class="order-price">
								{{ popType == 3 ? '预估订单金额' : '' }}
								{{ popType == 12 ? '支付订单金额' : '' }}
								：<span>￥{{ orderPrice.info.order_price }}</span>
							</p>
							<div class="order-infor-title" v-if="popType == 3">
								<span>需求信息</span>
								<div class="infor-btn" @click="onBindChangeProjectInfo">
									<img src="../assets/icon/bianji2@2x.png" alt="笔" />
									修改项目信息
								</div>
							</div>
							<table border="1" width="100%" class="infor-box">
								<tr>
									<td class="" width="17%">项目信息</td>
									<td>
										<div class="project-infor">
											<p>项目名称：{{ orderPrice.info.order_pro_name }}</p>
										</div>
										<div class="project-infor">
											<p>项目业态：{{ orderPrice.info.order_business }}</p>
											<p>相关项目：{{ orderPrice.info.order_is_dian }}</p>
											<p>设计面积：{{ orderPrice.info.order_area }} ㎡</p>
											<p>指定产品：{{ orderPrice.info.order_assign_pro }}</p>
										</div>
									</td>
								</tr>
								<tr>
									<td>需求信息</td>
									<td>
										<div class="order-demand">
											<!-- <p>
                        {{ orderPrice.info.order_require_design }}
                      </p> -->
											<p>
												<span v-for="(item, index) in orderRequireDetails" :key="index">
													{{ item.name }}{{ item.value ? ': （' + item.value + '）' : ''
													}}{{ orderRequireDetails.length - 1 == index ? '' : '、' }}
												</span>
											</p>
											<p v-if="orderPrice.info.order_dian_time">
												外出时间：{{ orderPrice.info.order_dian_time }}
											</p>
											<p v-if="orderPrice.info.order_dian_address">
												外出地址：{{ orderPrice.info.order_dian_address }}
											</p>
										</div>
									</td>
								</tr>
								<tr v-show="orderPrice.info.order_pro_remark">
									<td>备注</td>
									<td>
										<p class="order-note">
											{{ orderPrice.info.order_pro_remark }}
										</p>
									</td>
								</tr>
								<tr v-if="popType == 12">
									<td>交付时间</td>
									<td>
										<p class="order-note"> {{ orderPrice.info.order_require_time }} 天 </p>
									</td>
								</tr>
							</table>
							<p class="pay-time">
								{{ popType == 3 ? '请填写交付时间' : '需支付积分和金额' }}
							</p>
							<div class="order-time-box" v-if="popType == 3">
								<!-- <p>交付时间 :<span>*</span></p>
                <div class="order-input-box">
                  <input
                    type="number"
                    placeholder="请输入工作日天数"
                    v-model="deliveryTime"
                    :min="0"
                  />
                  <span>天</span>
                </div> -->
								<el-form
									:rules="deliveryRules"
									:model="deliveryTimeForm"
									ref="deliveryTimeForm"
									label-width="93px"
									class="demo-ruleForm"
								>
									<el-form-item label="交付时间: " prop="deliveryTime">
										<!-- oninput="if(value.length>5)value=value.slice(0,5)" -->
										<el-input
											type="number"
											:min="1"
											:max="99999"
											:maxlength="5"
											v-model.number="deliveryTimeForm.deliveryTime"
											oninput="if(value.length>5)value=value.slice(0,5)"
											placeholder="请输入工作日天数"
											autocomplete="off"
										>
											<span slot="suffix">天</span>
										</el-input>
									</el-form-item>
								</el-form>
							</div>
							<div class="pay-price-box" v-if="popType == 12">
								<p v-if="orderPrice.pay_price.pay_score > 0">
									支付积分: <span> {{ orderPrice.pay_price.pay_score }} </span>
								</p>
								<p v-if="orderPrice.pay_price.balance_money > 0">
									支付余额:<span> ￥ {{ orderPrice.pay_price.balance_money }} </span>
								</p>
								<p v-if="orderPrice.pay_price.pay_money > 0">
									支付金额:<span> ￥ {{ orderPrice.pay_price.pay_money }} </span>
								</p>

								<div class="pay-price-intro">
									注：1.优先支付积分，积分不足时补充金额。<br />
									2.交付日期从支付后开始计算，如延迟支付则顺延。
								</div>
							</div>
						</div>
					</template>
					<!-- 拒绝原因 -->
					<!-- 取消订单原因 -->
					<template v-if="popType == 8 || popType == 14 || popType == 2 || popType == 13">
						<div class="refused-box">
							<p class="refused-title">
								{{ popType == 8 || popType == 14 ? '请选择取消的原因' : '请选择拒绝原因' }}
							</p>
							<el-radio-group v-model="cancelRadio">
								<el-radio :label="1">{{ cancelRadioCorrespondText[popType][0] }}</el-radio>
								<el-radio :label="2">{{ cancelRadioCorrespondText[popType][1] }}</el-radio>
								<el-radio :label="3">{{ cancelRadioCorrespondText[popType][2] }}</el-radio>
								<el-radio :label="4">{{ cancelRadioCorrespondText[popType][3] }}</el-radio>
								<el-radio :label="5">其他</el-radio>
							</el-radio-group>
							<div class="refused-other-box" v-if="cancelRadio == 5">
								<p>其他原因:<span>*</span></p>
								<textarea
									:placeholder="cancelRadioCorrespondPl[popType]"
									v-model="cancelValue"
								></textarea>
							</div>
						</div>
					</template>
				</div>

				<template v-if="popType == 4">
					<div class="pay-succes">
						<img src="../assets/icon/success.png" alt="" />
						<div>
							<h5>已成功付款</h5>
							<p>
								支付积分: <span> {{ orderPrice.pay_price.pay_score }} </span>
							</p>
							<p>
								支付余额:<span> ￥ {{ orderPrice.pay_price.balance_money }} </span>
							</p>
							<p>
								支付金额:<span> ￥ {{ orderPrice.pay_price.pay_money }} </span>
							</p>
						</div>
					</div>
				</template>

				<!-- 上传方案  不通过-->
				<template v-if="popType == 5 || popType == 9">
					<div class="reason-failure">
						<h5>{{ selectItem.order_pro_name }}</h5>
						<div class="failure-content" v-if="popType == 9">
							<img src="../assets/icon/red_close.png" alt="拒絕" />
							<div>
								<div class="check-infor">
									<p class="check-type">不通过</p>
									<p class="check-time">
										<span>审核人：{{ refuseReason.audit_name }} </span>{{ refuseReason.time }}
									</p>
								</div>
								<h6>
									{{ refuseReason.remark }}
								</h6>
							</div>
						</div>
					</div>
					<div class="add-solution-box">
						<div class="choose-file-box">
							<el-upload
								class="upload-demo"
								:limit="20"
								:multiple="true"
								:file-list="planList"
								action=""
								:show-file-list="false"
								:before-upload="onBeforeUpload"
								:auto-upload="false"
								:on-change="getFile"
								style="display: flex; align-items: center"
							>
								<div>
									<i class="el-icon-plus"></i>
									<span>添加方案</span>
								</div>
							</el-upload>
							<!-- accept=".xls,.doc,.txt,.pdf" -->
							<!-- <input type="file" ref="upload" @change="getFile" /> -->
						</div>
						<div class="add-plan-box">
							<el-table
								ref="singleTable"
								:data="planList"
								tooltip-effect="dark"
								:header-cell-style="{
									backgroundColor: 'rgba(250, 250, 250, 0.4)',
								}"
								style="width: 100%"
								@select="handleSelectionChange"
							>
								<el-table-column prop="file_sort" align="center" label="序号" width="100">
									<template slot-scope="scope">
										{{ scope.$index < 9 ? '00' + (scope.$index + 1) : '0' + (scope.$index + 1) }}
									</template>
								</el-table-column>
								<el-table-column prop="file_name" label="方案名称" width="300"> </el-table-column>
								<el-table-column prop="file_exit" label="类型" show-overflow-tooltip>
									<template slot-scope="scope">
										<div v-if="!scope.row.percentage">
											{{ scope.row.file_exit }}
										</div>
										<div v-else>
											<div class="percentage-width">
												<el-progress
													:stroke-width="8"
													:percentage="scope.row.percentage"
													:show-text="false"
													status="success"
												></el-progress>
											</div>
											{{ scope.row.todo }} {{ scope.row.percentage }}%
										</div>
									</template>
								</el-table-column>
								<el-table-column fixed="right" label="操作" width="90">
									<template slot-scope="scope">
										<el-button
											v-if="!scope.row.percentage"
											@click="handleClick(scope.row, scope.$index)"
											type="text"
											size="small"
											>删除</el-button
										>
									</template>
								</el-table-column>
							</el-table>

							<div class="input-illustrate">
								<div class="title-illustrate">方案说明:</div>
								<div class="illustrate-input">
									<el-input
										type="textarea"
										placeholder="请输入内容"
										v-model="illustrateText"
										maxlength="200"
										show-word-limit
									>
									</el-input>
								</div>
							</div>
						</div>
					</div>
				</template>
				<template> </template>
				<!-- 评价方案 -->
				<template v-if="popType == 6">
					<div class="evaluation-box">
						<div class="evaluation-stars">
							<span>项目响应与交付时效：</span>
							<el-rate v-model="evaluationRadio" show-text :texts="showText"> </el-rate>
						</div>
						<div class="evaluation-stars">
							<span>方案专业与品质评价：</span>
							<el-rate v-model="evaluationRadio7" show-text :texts="showText"> </el-rate>
						</div>
						<div class="evaluation-stars">
							<span>设计师积极性与协作度：</span>
							<el-rate v-model="evaluationRadio8" show-text :texts="showText"> </el-rate>
						</div>

						<div class="refused-other-box">
							<p>评价补充:<span></span></p>
							<textarea
								placeholder="满意您就夸一夸，感谢您的每一个评价！"
								v-model="evaluationValue"
							></textarea>
						</div>
					</div>
				</template>
				<!-- 审核方案 验收方案 -->
				<template v-if="popType == 10 || popType == 11">
					<div class="operate-play-box">
						<div class="play-title-box">
							<p>{{ selectItem.order_pro_name }}</p>
							<div class="download-play" @click="goDownload">下载图纸</div>
						</div>
						<div class="add-plan-box">
							<el-table
								ref="singleTable"
								:data="planList"
								tooltip-effect="dark"
								:header-cell-style="{
									backgroundColor: 'rgba(250, 250, 250, 0.4)',
								}"
								style="width: 100%"
								@select="handleSelectionChange"
							>
								<el-table-column prop="file_sort" align="center" label="序号" width="100">
								</el-table-column>
								<el-table-column prop="file_name" label="方案名称" width="400"> </el-table-column>
								<el-table-column prop="file_exit" label="类型" show-overflow-tooltip>
								</el-table-column>
								<el-table-column label="操作" show-overflow-tooltip prop="file_sort">
									<template slot-scope="scope">
										<span
											class="btn_box"
											@click="downloadItem2(scope.row, scope.row.file_name + scope.row.file_exit)"
											>下载</span
										>
									</template>
								</el-table-column>
							</el-table>

							<div class="refused-box">
								<p class="refused-title">审核结果：</p>
								<el-radio-group v-model="auditRadio">
									<el-radio :label="1">通过</el-radio>
									<el-radio :label="2">不通过</el-radio>
								</el-radio-group>
								<div class="refused-other-box" v-if="auditRadio == 2">
									<p>不通过原因 :<span>*</span></p>
									<textarea placeholder="请输入" v-model="auditValue"></textarea>
								</div>
							</div>
						</div>
					</div>
				</template>

				<!-- 上级审批 -->
				<template v-if="popType==15">
					<div class="operate-play-box">
						<div class="refused-box">
								<p class="refused-title">审批结果：</p>
								<el-radio-group v-model="lead.type">
									<el-radio :label="1">通过</el-radio>
									<el-radio :label="2">不通过</el-radio>
								</el-radio-group>
								<div class="refused-other-box" v-if="lead.type == 2">
									<p>不通过原因 :<span>*</span></p>
									<textarea placeholder="请输入" v-model="lead.reject_reason"></textarea>
								</div>
							</div>
					</div>
					
				</template>


				<div class="line-block"></div>
				<div class="designer-btn-box">
					<template
						v-if="
							popType == 1 ||
							popType == 2 ||
							popType == 3 ||
							popType == 5 ||
							popType == 6 ||
							popType == 7 ||
							popType == 8 ||
							popType == 9 ||
							popType == 10 ||
							popType == 11 ||
							popType == 12 ||
							popType == 13 ||
							popType == 14 ||
							popType == 15
						"
					>
						<div class="cancel-btn" @click="handleCloseDetail">取消</div>
						<div
							class="sure-btn"
							v-if="popType != 5 && popType != 12 && popType != 9 && popType != 15"
							@click="surePop"
						>
							确定
						</div>
						<div class="sure-btn" v-if="popType == 5 || popType == 9" @click="palnSubmit">
							提交审核
						</div>
						<div class="sure-btn" v-if="popType == 15" @click="leadAuth">
							提交审批
						</div>
					</template>
					<div class="sure-btn" v-if="popType == 4" @click="closePop('完成支付，订单设计中')">
						完成
					</div>
					<div class="sure-btn" @click="payTypeJudgeDoing" v-if="popType == 12"> 支付 </div>
				</div>
			</div>
		</el-drawer>

		<el-drawer
			title="二级弹窗"
			custom-class="drawer-width"
			:with-header="false"
			:wrapperClosable="false"
			:visible="secondPopType > 0"
			:direction="direction"
			:before-close="handleCloseDetail"
			size="41%"
		>
			<div class="">
				<div class="title-drawer">
					<div class="title-text">{{ secondaryPopupName[secondPopType] }}</div>
					<div class="opera-pop-box">
						<div class="opera-back" @click="secondPopType = 0">
							<i class="el-icon-arrow-left"></i>返回上一页
						</div>

						<div class="close-title-drawer" @click="handleCloseDetail">
							<i class="el-icon-close"></i>
						</div>
					</div>
				</div>
				<div class="second-content-box" v-if="secondPopType == 1">
					<div class="pay-info-box">
						<el-image class="pay-code" alt="付款二维码" :src="payInfor.temporary_url" lazy>
							<div slot="error" class="image-slot"> <i class="el-icon-picture-outline"></i></div
						></el-image>
						<!-- <img
              class="pay-code"
              :src="payInfor.temporary_url"
              alt="付款二维码"
            /> -->
						<div class="">
							<p class="pay-amount">
								支付金额：<span>￥{{ payInfor.pay_money }}</span>
							</p>
							<p class="pay-intro">余额不足，请扫码支付</p>
							<div class="pay-type">
								<img class="pay-code" src="../../src/assets/icon/wx.png" alt="付款二维码" /><span
									>微信支付</span
								>
							</div>
							<p class="pay-end-time">
								距离二维码过期还剩{{ payTime }}秒，过期后请刷新二维码重新获取
							</p>
						</div>
					</div>
					<div class="check-pay-btn" @click="checkPay">我已付款</div>
				</div>
				<div class="second-content-box" v-if="secondPopType == 2" v-loading="projectInfoLoading">
					<div class="modify-the-form-title" v-if="demandServiceList.order_info">
						{{ demandServiceList.order_info.order_pro_name }}
					</div>
					<div class="modify-the-form-info">
						<div class="form-info-item">
							申请人:
							<span>{{ demandServiceList.order_info.order_apply_name }}</span>
						</div>
						<div class="form-info-item">
							手机号:
							<span>{{ demandServiceList.order_info.order_phone }}</span>
						</div>
						<div class="form-info-item">
							邮箱:
							<span>{{ demandServiceList.order_info.order_email }}</span>
						</div>
					</div>
					<div class="modify-the-form-title">项目信息</div>

					<div class="form-shelf-height">
						<el-form
							:model="ruleForm"
							:rules="rules"
							ref="ruleForm"
							class="demo-ruleForm"
							label-width="100px"
							label-position="left"
						>
							<el-form-item label="项目业态" required class="form-label right-margin format-inline">
								<el-form-item prop="order_business">
									<el-select
										class="adjacent-select"
										v-model="ruleForm.order_business"
										placeholder="请选择"
										:disabled="orderPrice.info.crm_order_type == 1"
										@change="changeBusinessClass"
									>
										<el-option
											:label="item.name"
											:value="item.id"
											v-for="(item, index) in businessClassification"
											:key="index"
										></el-option>
									</el-select>
								</el-form-item>
								<el-form-item prop="order_child_business">
									<el-select
										class="adjacent-select"
										v-model="ruleForm.order_child_business"
										placeholder="请选择"
										:disabled="businessSubclass.length == 0 || orderPrice.info.crm_order_type == 1"
										@change="changeBusinessSubclass"
									>
										<el-option
											:label="item.name"
											:value="item.id"
											v-for="(item, index) in businessSubclass"
											:key="index"
										></el-option>
									</el-select>
								</el-form-item>
							</el-form-item>
							<!-- 业态 end -->
							<el-form-item label="项目名称" prop="order_pro_name" class="form-label not">
								<el-input
									class="form-input"
									placeholder="请输入联系的项目名称"
									:disabled="orderPrice.info.crm_order_type == 1"
									v-model="ruleForm.order_pro_name"
								></el-input>
							</el-form-item>
							<!-- 项目名称 end -->
							<el-form-item label="设计面积" prop="order_pro_area" class="form-label">
								<el-input
									class="form-input"
									placeholder="请输入设计面积"
									type="number"
									min="1"
									v-model.number="ruleForm.order_pro_area"
									@change="changeOrderProArea"
								>
									<template slot="suffix">
										<div class="suffix-input">㎡</div>
									</template></el-input
								>
							</el-form-item>
							<!-- 设计面积 -->
							<el-form-item label="相关项目" class="form-label not">
								<el-select
									class="form-select"
									v-model="ruleForm.order_bind_id"
									placeholder="请选择相关项目"
									clearable
									@change="changeSelectedOrderBindId"
								>
									<el-option
										:label="item.order_pro_name"
										:value="item.id"
										v-for="(item, index) in assoItemsAndSpecPro.project"
										:key="index"
									></el-option>
								</el-select>
							</el-form-item>
							<!-- 相关项目 end -->
							<el-form-item label="指定产品" class="form-label">
								<el-select
									class="form-select"
									clearable
									v-model="ruleForm.order_assign_pro"
									placeholder="请选择指定产品"
								>
									<el-option
										:label="item.name"
										:value="item.id"
										v-for="(item, index) in assoItemsAndSpecPro.product"
										:key="index"
									></el-option>
								</el-select>
							</el-form-item>
							<!-- 指定产品 end -->
							<el-form-item label="备注:" class="form-label not">
								<el-input
									class="textarea-form"
									type="textarea"
									placeholder="请输入备注信息"
									v-model="ruleForm.order_pro_remark"
								></el-input>
							</el-form-item>
						</el-form>
						<el-form ref="serveForm" :model="serveForm" label-width="120px" label-position="left">
							<div class="info-title">
								需求信息
								<!-- <div
                  class="check-details"
                  @click="closeOrOpenFixedCheckDetails"
                >
                  查看需求明细
                </div> -->
							</div>
							<!-- 信息输入 标题 end -->
							<el-form-item
								class="screen-two-form-lalbel"
								label="方案服务:"
								v-if="demandServiceList.fafw && demandServiceList.fafw.length > 0"
							>
								<el-checkbox
									v-for="(item, index) in demandServiceList.fafw"
									:key="index"
									v-model="item.select"
									:label="item.name"
									:true-label="1"
									:false-label="0"
									@change="changeServiceSelect($event, item)"
								></el-checkbox>
							</el-form-item>
							<el-form-item
								class="screen-two-form-lalbel"
								label="外出服务:"
								v-if="demandServiceList.wcfw && demandServiceList.wcfw.length > 0"
							>
								<el-checkbox
									v-for="(item, index) in demandServiceList.wcfw"
									:key="index"
									v-model="item.select"
									:label="item.name"
									:true-label="1"
									:false-label="0"
									@change="changeServiceSelect($event, item)"
								></el-checkbox>
							</el-form-item>
						</el-form>
						<el-form ref="needForm" label-width="180px" label-position="right">
							<div class="form-title-screen-two" v-if="serveForm_id.length > 0">
								请选择需求数量:
							</div>
							<div class="form-screen-main">
								<el-form-item
									v-if="serveForm_id.indexOf('3') != -1"
									class="form-label"
									:label="illuminationCalculation.child[0].name"
									required
								>
									<el-input
										class="form-input"
										type="number"
										:placeholder="`请输入${illuminationCalculation.child[0].name}数量`"
										v-model="illuminationCalculation.child[0].dw_num"
										@change="
											enterAloneCase($event, {
												keyName: 'illuminationCalculation',
												value: illuminationCalculation,
											})
										"
									>
										<template slot="suffix">
											<div class="suffix-input">
												{{ illuminationCalculation.child[0].dw_name }}
											</div>
										</template>
									</el-input>
								</el-form-item>
								<!-- 空间数量 end -->
								<el-form-item
									class="form-label"
									v-if="serveForm_id.indexOf('4') != -1"
									:label="intelligentSolutions.name"
									required
								>
									<el-radio
										v-for="(item, index) in intelligentSolutions.child"
										:key="index"
										v-model="intelligentSolutions.radioGroup"
										@change="
											chageRadioCase($event, {
												keyName: 'intelligentSolutions',
												value: intelligentSolutions,
											})
										"
										:label="item.id"
										>{{ item.name }}</el-radio
									>
								</el-form-item>
								<!-- 智能标准方案 end -->
								<el-form-item
									class="form-label"
									v-if="serveForm_id.indexOf('6') != -1"
									:label="pptProductPlanType.name"
									required
								>
									<el-radio
										v-for="(item, index) in pptProductPlanType.child"
										:key="index"
										v-model="pptProductPlanType.radioGroup"
										@change="
											chageRadioCase($event, {
												keyName: 'pptProductPlanType',
												value: pptProductPlanType,
											})
										"
										:label="item.id"
										>{{ item.name }}</el-radio
									>
								</el-form-item>
								<!-- 智能PPT方案制作类型 end -->
								<el-form-item
									class="form-label"
									v-if="serveForm_id.indexOf('7') != -1"
									:label="renderings.name"
									required
								>
									<el-form-item>
										<div class="checkbox-input-group">
											<div
												class="checkbox-input"
												v-for="(item, index) in renderings.child"
												:key="index"
											>
												<el-checkbox
													v-model="item.select"
													:label="item.name"
													:true-label="1"
													:false-label="0"
													@change="
														changeCheckBoxCase($event, {
															keyName: 'renderings',
															value: renderings,
														})
													"
												>
												</el-checkbox>
												<el-form-item v-if="item.select">
													<el-input
														class="renderings-input"
														placeholder="请输入"
														type="number"
														v-model="item.dw_num"
														@change="
															changeCheckBoxInput($event, {
																keyName: 'renderings',
																value: renderings,
																index: index,
															})
														"
														maxlength="6"
														minlength="1"
													>
														<template slot="suffix">
															<div class="suffix-input">{{ item.dw_name }}</div>
														</template>
													</el-input>
												</el-form-item>
											</div>
										</div>
									</el-form-item>
								</el-form-item>
								<!-- 效果图 end -->
								<el-form-item
									class="form-label"
									v-if="serveForm_id.indexOf('9') != -1"
									:label="designTraining.child[0].name"
									required
								>
									<el-input
										class="form-input"
										type="number"
										min="1"
										v-model="designTraining.child[0].dw_num"
										:placeholder="`请输入${designTraining.child[0].name}天数`"
										@change="
											enterAloneCase($event, {
												keyName: 'designTraining',
												value: designTraining,
											})
										"
									>
										<template slot="suffix">
											<div class="suffix-input">
												{{ designTraining.child[0].dw_name }}
											</div>
										</template>
									</el-input>
								</el-form-item>
								<!-- 设计推广/设计培训 end -->
								<el-form-item
									class="form-label"
									v-if="serveForm_id.indexOf('8') != -1"
									:label="programReport.name"
									required
								>
									<el-form-item>
										<div class="checkbox-input-group">
											<div
												class="checkbox-input"
												v-for="(item, index) in programReport.child"
												:key="index"
											>
												<el-radio
													:label="item.id"
													v-model="programReport.radioGroup"
													@change="
														chageRadioCase($event, {
															keyName: 'programReport',
															value: programReport,
														})
													"
													>{{ item.name }}</el-radio
												>
												<el-form-item>
													<el-input
														class="renderings-input"
														v-model="item.dw_num"
														v-if="programReport.radioGroup == item.id"
														@change="
															chageRadioInput($event, {
																keyName: 'programReport',
																value: programReport,
																index: index,
															})
														"
														type="number"
														placeholder="请输入"
													>
														<template slot="suffix">
															<div class="suffix-input">
																{{ item.dw_name }}
															</div>
														</template>
													</el-input>
												</el-form-item>
											</div>
										</div>
									</el-form-item>
								</el-form-item>
								<!-- 方案汇报天数 end -->
								<el-form-item
									v-if="serveForm_id.indexOf('10') != -1"
									class="form-label"
									:label="technicalSupport.name"
									required
								>
									<el-form-item>
										<div class="checkbox-input-group">
											<div
												class="checkbox-input"
												v-for="(item, index) in technicalSupport.child"
												:key="index"
											>
												<el-radio
													:label="item.id"
													v-model="technicalSupport.radioGroup"
													@change="
														chageRadioCase($event, {
															keyName: 'technicalSupport',
															value: technicalSupport,
														})
													"
													>{{ item.name }}</el-radio
												>
												<el-form-item>
													<el-input
														class="renderings-input"
														placeholder="请输入"
														type="number"
														v-if="technicalSupport.radioGroup == item.id"
														v-model="item.dw_num"
														@change="
															chageRadioInput($event, {
																keyName: 'technicalSupport',
																value: technicalSupport,
																index: index,
															})
														"
													>
														<template slot="suffix">
															<div class="suffix-input">{{ item.dw_name }}</div>
														</template>
													</el-input>
												</el-form-item>
											</div>
										</div>
									</el-form-item>
								</el-form-item>
								<!-- 现场技术支持 end -->
								<el-form-item
									v-if="serveForm_id.indexOf('11') != -1"
									class="form-label"
									:label="afterSalesService.child[0].name"
									required
								>
									<el-input
										v-model="afterSalesService.child[0].dw_num"
										class="form-input"
										placeholder="请输入智能售后服务天数"
										@change="
											enterAloneCase($event, {
												keyName: 'afterSalesService',
												value: afterSalesService,
											})
										"
									>
										<template slot="suffix">
											<div class="suffix-input">
												{{ afterSalesService.child[0].dw_name }}
											</div>
										</template>
									</el-input>
								</el-form-item>
								<!-- 智能售后服务 end -->
								<el-form-item
									v-if="serveForm_id.indexOf('12') != -1"
									class="form-label peripherals"
									:label="externalDeviceDocking.name"
									required
								>
									<el-form-item>
										<el-form-item prop="deviceDockingType">
											<div class="checkbox-input-group">
												<div
													class="checkbox-input"
													v-for="(item, index) in externalDeviceDocking.child"
													:key="index"
												>
													<el-checkbox
														v-model="item.select"
														@change="
															changeCheckBoxCase($event, {
																keyName: 'externalDeviceDocking',
																value: externalDeviceDocking,
															})
														"
														:label="item.id"
														:true-label="1"
														:false-label="0"
													>
														{{ item.name }}
													</el-checkbox>
													<el-form-item>
														<el-input
															class="renderings-input"
															placeholder="请输入"
															type="number"
															v-if="item.select == 1"
															v-model="item.dw_num"
															@change="
																changeCheckBoxInput($event, {
																	keyName: 'externalDeviceDocking',
																	value: externalDeviceDocking,
																	index: index,
																})
															"
															maxlength="6"
															minlength="1"
														>
															<template slot="suffix">
																<div class="suffix-input">
																	{{ item.dw_name }}
																</div>
															</template>
														</el-input>
													</el-form-item>
												</div>
											</div>
										</el-form-item>
									</el-form-item>
								</el-form-item>
								<!-- 第三方设备对接类型 end -->
								<el-form-item
									v-show="serveForm.outboundService.length > 0"
									class="form-label"
									label="外出时间:"
									required
								>
									<el-date-picker
										v-model="order_dian_time"
										type="datetime"
										value-format="yyyy-MM-dd HH:mm:ss"
										placeholder="请选择外出时间"
										:picker-options="pickerOptions"
										@change="changeDatePicker"
									>
									</el-date-picker>
								</el-form-item>
								<!-- crm智能标准方案 -->

								<el-form-item
									class="form-label"
									v-if="serveForm_id.indexOf('45') != -1"
									:label="crmIntelligentSolutions.name"
									required
								>
									<el-radio
										v-for="(item, index) in crmIntelligentSolutions.child"
										:key="index"
										v-model="crmIntelligentSolutions.radioGroup"
										@change="
											chageRadioCase($event, {
												keyName: 'crmIntelligentSolutions',
												value: crmIntelligentSolutions,
											})
										"
										:label="item.id"
										>{{ item.name }}</el-radio
									>
								</el-form-item>
								
								<!-- crm户外设计 -->
								<el-form-item
									class="form-label"
									v-if="serveForm_id.indexOf('47') != -1"
									:label="crmOutdoor.name"
									required
								>
									<el-radio
										v-for="(item, index) in crmOutdoor.child"
										:key="index"
										v-model="crmOutdoor.radioGroup"
										@change="
											chageRadioCase($event, {
												keyName: 'crmOutdoor',
												value: crmOutdoor,
											})
										"
										:label="item.id"
										>{{ item.name }}</el-radio
									>
								</el-form-item>

								<!-- 外出时间 end -->
								<el-form-item
									v-show="serveForm.outboundService.length > 0"
									class="form-label"
									label="外出地址:"
									required
								>
									<el-input
										class="form-input address"
										type="textarea"
										v-model="order_dian_address"
										:autosize="{ minRows: 2, maxRows: 6 }"
										placeholder="请输入外出地址"
										resize="none"
									></el-input>
								</el-form-item>
								<!-- 外出地址 end -->
							</div>
						</el-form>
					</div>
					<div class="submit-form-order-edit">
						<el-button size="small" @click="secondPopType = 0">取消</el-button>
						<el-button class="form-order-confirm" size="small" @click="submitForm('ruleForm')"
							>确定</el-button
						>
					</div>
				</div>
			</div>
		</el-drawer>
		<down-zip
			ref="downzip"
			:list="[]"
			urlName="url"
			imgName="file_name"
			suffixName="file_exit"
			v-if="popType == 10 || popType == 11"
		></down-zip>

		<!-- 单文件下载 -->
		<single-file-download ref="singleFileDownload"></single-file-download>
	</div>
</template>

<script>
	import downZip from '../components/downLoadZip.vue';
	import singleFileDownload from '../components/singleFileDownload.vue';
	import {
		$orderDesignList,
		$allocationDesign,
		$cancelOrder,
		$refusedAllocation,
		$agreeAllocation,
		$allocationChildDesig,
		$childRefusedAllocation,
		$childAgreeAllocation,
		$planList,
		$reportPrice,
		$quotedPrice,
		$palnAudit,
		$palnAcceptance,
		$planEdit,
		$requestAssist,
		$firmPrice,
		$orderPayInfo,
		$payQrCode,
		$palnEvaluate,
		$delPlan,
		$uploadPlan,
		$palnSubmit,
		$leadAuth,
		$queryPay,
		$afterSales,
		$refundRefusedConfirm,
		// 获取业态
		$place_orderBusiness_type,
		// 获取 关联项目
		$placeOrderRelation_project,
		// 获取下单信息
		$placeOrderPage,
		// 编辑下单
		$placeOrderEdit,
		// 判断支付类型
		$orderIsPayType,
		//余额支付
		$orderPayBalance,
		// 分片上传 标识符
		$uploadOnlySplitOn,
		// 分片上传
		$uploadOnlySplitUpload,

		// 获取关联项目和指定产品(编辑页)
		$relationProjectEdit,

		// 获取个人信息
		$userDetail,
	} from '@/api';
	const _delay = delayDither(600);
	export default {
		name: 'operation',
		props: {
			popType: {
				type: Number,
				default: 0,
			},
		},
		watch: {
			popType(newVal, oldVal) {
				if (newVal == 0) {
					this.deliveryTime = '';
				}
			},
			// "serveForm.outboundService"(newVal, oldVal) {
			//   if (newVal.length == 0) {
			//     // 外出地址
			//     this.order_dian_address = "";
			//     // 外出时间
			//     this.order_dian_time = "";
			//   }
			// },
			secondPopType(newVal, oldVal) {
				if (newVal == 0) {
					// 离开二级弹窗 清除定时器
					clearInterval(this.endTime);
				}
			},
		},
		components: { downZip, singleFileDownload },
		data() {
			// 效验交付时间
			let rulesDeliveryTime = (rule, value, callback) => {
				if (value > 0) {
					callback();
				} else {
					callback(new Error('请输入正确的交付时间'));
				}
			};
			// 设计面积校验
			var validateOrderProArea = (rule, value, callback) => {
				if (value <= 0) {
					return callback(new Error('面积不能小于0'));
				} else if (value > 100000) {
					return callback(new Error('设计面积大于十万平方米'));
				} else {
					return callback();
				}
			};

			return {
				illustrateText: '',
				projectInfoLoading: false,
				suffix_text: [
					'jpg',
					'jpeg',
					'gif',
					'png',
					'bmp',
					'pdf',
					'tif',
					'doc',
					'docx',
					'xls',
					'xlsx',
					'txt',
					'rar',
					'zip',
					'skp',
					'max',
					'dwg',
					'dxf',
					'gz',
					'ppt',
					'pptx',
				],
				un_showNeedTodo: false,
				un_showNeedTodoList: [1, 2, 4, 5],
				selecedCheckDetails: [],

				deliveryTimeForm: {
					deliveryTime: '',
				},
				deliveryRules: {
					deliveryTime: [
						{
							required: true,
							message: '交付时间不能为空',
							trigger: ['blur', 'change'],
						},
						{ validator: rulesDeliveryTime, trigger: ['blur', 'change'] },
					],
				},
				designerSearchValue: '',
				user_code: '',
				cancelRadioCorrespondText: {
					8: ['图纸不全', '需求变更', '业主不想要了', '下错订单', '其他'],
					14: ['图纸不全', '需求变更', '业主不想要了', '下错订单', '其他'],
					2: ['填错资料', '图纸不全', '项目搁置', '交付时间不符合需求', '其他'],
					13: ['填错资料', '图纸不全', '项目搁置', '交付时间不符合需求', '其他'],
				},
				cancelRadioCorrespondPl: {
					8: '请输入您取消订单的原因',
					14: '请输入您撤单的原因',
					2: '请输入您拒绝分配的原因',
					13: '请输入您拒绝协助的原因',
				},

				// 单选 类型 特殊处理
				radioGroupSpecialintroduce: [4,6, 8, 10,45,47],
				secondaryPopupName: ['', '支付金额', '修改项目信息'],
				direction: 'rtl',
				//popType: 2, //1分配主责设计师 2拒绝分配 3订单报价 4支付成功 5上传方案 6评价方案 7分配协助设计师 8取消订单 9修改方案 10审核方案 11验收方案 12 支付报价 新增 13 拒绝协助 14 撤单 15 上级审批
				popTitle: [
					'',
					'分配主责设计师',
					'拒绝分配',
					'订单确认',
					'支付报价',
					'上传方案',
					'评价方案',
					'分配协助设计师',
					'取消订单',
					'修改方案',
					'审核方案',
					'验收方案',
					'支付报价',
					'拒绝协助',
					'取消订单',
					'订单审批'
				],
				pickerOptions: {
					disabledDate(time) {
						//只能选择今天及今天之前的日期
						// return time.getTime() > Date.now();
						//只能选择今天及今天之后的日期
						return time.getTime() < Date.now() - 8.64e6; //只能选择今天之后的日期，今天的日期也不能选
					},
				},
				secondPopType: 0, //0为一级 二级页面 1支付页面 2 修改信息
				cancelRadio: 1, //取消订单
				cancelValue: '', //其他原因输入的
				endTime: null, //支付倒计时

				auditRadio: 1, //审核选项 1通过 2不通过
				auditValue: '', //不通过原因
				evaluationRadio: 5, //项目响应与交付时
				evaluationRadio7:5, // 方案专业与品质评价
				evaluationRadio8:5, // 设计师积极性与协作度
				evaluationValue: '', //评分内容

				showText: ['1分', '2分', '3分', '4分', '5分'],
				// 设计师分页
				designPaging: {
					id: null,
					page: 1,
					limit: 13,
				},
				selectItem: {}, //选中的行
				//设计师列表
				designList: {},
				//方案列表
				planList: [],
				//订单报价
				orderPrice: {
					info: {},
					pay_price: {},
				},
				//交付时间
				deliveryTime: '',
				//二维码支付信息
				payInfor: {
					temporary_url: '',
				},
				//支付时间
				payTime: null,
				//拒绝原因
				refuseReason: {},

				// 基本填写信息
				ruleForm: {
					order_apply_name: '', // 姓名
					order_phone: '', // 手机
					order_email: '', // 邮箱
					order_business: '', // 项目业态 住宅类型
					order_child_business: '', // 项目业态 建筑类型
					order_pro_name: '', // 项目名称
					order_pro_area: '', // 设计面积
					order_bind_id: '', // 相关项目
					order_assign_pro: '', // 指定产品
					order_assign_id: '', // 指定产品 id
					order_pro_remark: '', // 备注
				},
				// 基本填写信息 校验
				rules: {
					order_business: [{ required: true, message: '请选择住宅', trigger: 'change' }],
					order_child_business: [{ required: true, message: '请选择住宅类型', trigger: 'change' }],
					order_pro_name: [
						{ required: true, message: '请输入项目名称', trigger: 'blur' },
						{
							min: 3,
							max: 256,
							message: '长度在 3 到 256 个字符',
							trigger: 'blur',
						},
					],
					order_pro_area: [
						{ required: true, message: '请输入设计面积', trigger: 'blur' },
						{ validator: validateOrderProArea, trigger: 'change' },
					],
				},
				//业态分类 主类
				businessClassification: [],
				//业态分类 子类
				businessSubclass: [],
				//关联项目和指定产品
				assoItemsAndSpecPro: {},
				/*  */
				demandServiceList: {
					order_info: {},
					fafw: {},
				},
				// 选择 服务信息
				serveForm: {
					// 方案服务
					solutionService: [],
					// 外出服务
					outboundService: [],
				},
				// 外出地址
				order_dian_address: '',
				// 外出时间
				order_dian_time: '',
				serveForm_id: [],
				// 照度计算
				illuminationCalculation: {},
				// 智能标准方案
				intelligentSolutions: {},
				// ppt 制作方案类型
				pptProductPlanType: {},
				// 效果图
				renderings: {},
				// 设计培训 / 设计类型
				designTraining: {},
				// 方案汇报天数
				programReport: {},
				// 现场技术支持
				technicalSupport: {},
				// 智能售后服务
				afterSalesService: {},
				// 第三方设备对接类型
				externalDeviceDocking: {},
				// crm智能标准方案
				crmIntelligentSolutions: {},
				// crm户外设计
				crmOutdoor:{},
				// 输入类型 对应id 对应数据
				order_require_design: [],
				inputTypeId: {
					3: {
						// 照度计算
						keyValuePair: 'illuminationCalculation',
					},
					4: {
					// 智能标准方案
					keyValuePair: "intelligentSolutions",
					},
					6: {
						// ppt 制作方案类型
						keyValuePair: 'pptProductPlanType',
					},
					7: {
						// 效果图
						keyValuePair: 'renderings',
					},
					8: {
						// 方案汇报天数
						keyValuePair: 'programReport',
					},
					9: {
						// 设计培训 / 设计类型
						keyValuePair: 'designTraining',
					},
					10: {
						// 现场技术支持
						keyValuePair: 'technicalSupport',
					},
					11: {
						// 智能售后服务
						keyValuePair: 'afterSalesService',
					},
					12: {
						// 第三方设备对接类型
						keyValuePair: 'externalDeviceDocking',
					},
					45:{
						// crm智能标准方案
						keyValuePair: "crmIntelligentSolutions",
					},
					// crm户外设计
					47:{
          keyValuePair: "crmOutdoor",
        }
				},

				orderRequireDetails: null,
				lead:{
					type:0,
					reject_reason:''
				}
			};
		},
		mounted() {
			// this.onBindChangeProjectInfo();
			let { user_code } = this.$store.state.userInfo;
			this.user_code = user_code;
		},
		methods: {
			// 获取个人信息
			getUserInfo() {
				$userDetail()
					.then((res) => {
						// console.log('------测试------');
						this.$store.commit('SetUserInfo', res.data);
						this.$parent.$parent.userInfo = res.data; // 修改侧边栏用户数据
						this.$forceUpdate();
					})
					.catch((err) => {
						console.log(err);
					});
			},

			// 下载 单文件
			downloadItem2(file, file_title) {
				// console.log( 'file - file_title', file, file_title);
				this.$refs['singleFileDownload'].downloadItem(file, file_title);
			},

			changeDatePicker(fomrat) {
				// console.log(fomrat);
			},
			//弹窗确定
			surePop() {
				_delay(() => {
					//分配设计师
					if (this.popType == 1 || this.popType == 7) {
						if (this.designItem.length <= 0) return;
						this.allocationDesign();
						return;
					}
					//确认报价
					if (this.popType == 3) {
						// this.$refs.deliveryTimeForm.validateField(() => {

						// })
						this.$refs['deliveryTimeForm'].validate((valid) => {
							if (valid) {
								this.deliveryTime = this.deliveryTimeForm.deliveryTime;

								this.postQuotedPrice(); // 提交报价
							} else {
								this.$message.error({
									message: '请输入正确的交付时间！',
									showClose: true,
								});
								return false;
							}

							// if (this.deliveryTime > 0) {
							//   this.postQuotedPrice();
							// }
							// return;
						});
					}
					//方案评价
					if (this.popType == 6) {
						this.postPalnEvaluate();
						return;
					}

					//方案审核
					if (this.popType == 10 || this.popType == 11) {
						this.postPalnAudit();
						return;
					}
					//取消订单 拒绝分配 协助  撤单
					if (this.popType == 8 || this.popType == 2 || this.popType == 13 || this.popType == 14) {
						if (this.cancelRadio == 5 && this.cancelValue.trim().length == 0) {
							this.$message({
								showClose: true,
								message: '请先输入其他原因',
								type: 'warning',
							});
							return;
						}
						this.cancelOrder();
						return;
					}
				});
			},
			//申请售后 撤单
			afterSales() {
				$afterSales({ id: this.selectItem.id }).then((res) => {
					this.$message({
						showClose: true,
						message: '撤单申请已提交，请耐心等待撤单审核',
						type: 'warning',
					});
				});
			},
			checkDesignerSearch() {
				this.designPaging.page = 1;
				this.getOrderDesignList(this.popType);
			},
			//检查是否支付
			checkPay() {
				$queryPay({ id: this.selectItem.id }).then((res) => {
					if (res.data.pay) {
						this.$parent.popType = 4;
						this.secondPopType = 0;
					} else {
						this.$message({
							showClose: true,
							message: '暂未支付，稍后重试',
							type: 'warning',
						});
					}
				});
			},
			//修改方案
			postPlanEdit() {
				// console.log(this.selectItem, "selectItem");
				$planEdit({ id: this.selectItem.id }).then((res) => {
					this.refuseReason = res.data.info;
					this.illustrateText = res.data.info.project_instruction || '';
					this.planList = res.data.list;
				});
			},
			//方案提交
			palnSubmit() {
				_delay(() => {
					let fileLoadding = this.checkFileLoading();
					if (fileLoadding) {
						return;
					}
					$palnSubmit({
						id: this.selectItem.id,
						project_instruction: this.illustrateText,
					}).then((res) => {
						this.closePop('提交成功');
					});
				});
			},
			// 上级领导审批
			leadAuth(){
				_delay(() => {
					let fileLoadding = this.checkFileLoading();
					if (fileLoadding) {
						return;
					}
					$leadAuth({
						id: this.selectItem.id,
						type: this.lead.type,
						reject_reason: this.lead.reject_reason
					}).then((res) => {
						this.closePop('提交成功');
					});
				});

			},
			//删除文件
			handleClick(item, index) {
				_delay(() => {
					let params = {
						id: this.selectItem.id,
						file_ids: item.id,
					};
					$delPlan(params).then(() => {
						this.planList.splice(index, 1);

						this.$message({
							showClose: true,
							message: '刪除成功',
							type: 'success',
						});
					});
				});
			},
			//方案评价
			postPalnEvaluate() {
				let params = {
					id: this.selectItem.id,
					star: this.evaluationRadio,
					star7:this.evaluationRadio7,
					star8:this.evaluationRadio8,
					remark: this.evaluationValue,
				};
				$palnEvaluate(params).then((res) => {
					this.closePop('评论成功');
				});
			},
			// 支付类型判断 进行支付
			payTypeJudgeDoing() {
				// let params = {
				//   area: "总部",
				//   createtime: '',
				//   expires_in: '',
				//   expiretime: '',
				//   id: '',
				//   organization_id: 8,
				//   position: "前端",
				//   real_name: "经销商文",
				//   token: "",
				//   user_Email: "",
				//   user_bu_meng: "",
				//   user_code: 1,
				//   user_code_name: "经销商",
				//   user_company: "一匠科技",
				//   user_head_img: "https://cdn-design.oss-accelerate.aliyuncs.com/design/upload/2022-08-12/2b276fd066b430ed6ab89ef82.jpg?OSSAccessKeyId=LTAI4FuCdXnVWfnKJu3SFHRo&Expires=1660370191&Signature=pioGVlxY8YyWFJQujm1WOrt1mH4%3D",
				//   user_id: '',
				//   user_is_member_grade: 2,
				//   user_is_member_name: "白银会员",
				//   user_name: "wh003",
				//   user_openid: null,
				//   user_phone: "",
				//   user_price: "1000.00",
				//   user_score: "1000.00",
				//   user_trump: null,
				// }

				// this.$store.commit("SetUserInfo", params);
				// this.$parent.$parent.userInfo = params;
				// console.log('------vuex------', this.$store.state.userInfo);
				// console.log(this.$parent.$parent.userInfo);

				$orderIsPayType({
					id: this.selectItem.id,
				})
					.then((res) => {
						if (res) {
							switch (res.data) {
								case '1':
									this.payOrder();
									break;
								case '2':
									this.payBalanceOrder();
									break;
							}
						}
					})
					.catch((err) => {
						console.log(err);
					});
			},
			// 余额支付
			payBalanceOrder() {
				$orderPayBalance({
					id: this.selectItem.id,
				})
					.then((res) => {
						if (res.data) {
							this.$message({
								showClose: true,
								message: '支付成功',
								type: 'success',
							});
							this.$parent.popType = 4;
							this.secondPopType = 0;
						} else {
							this.$message({
								showClose: true,
								message: '支付失败',
								type: 'error',
							});
						}

						this.getUserInfo();
					})
					.catch((err) => {
						this.$message({
							showClose: true,
							message: '支付异常',
							type: 'error',
						});
					});
			},
			//支付信息
			payOrder() {
				let that = this;
				this.secondPopType = 1;
				$payQrCode({ id: this.selectItem.id }).then((res) => {
					that.payInfor = res.data;
					that.payTime = res.data.time;
					that.endTime = setInterval(() => {
						that.payTime--;
						if (that.payTime <= 0) {
							clearInterval(that.endTime);
							this.payOrder();
							this.getUserInfo();
						}
					}, 1000);
				});
			},
			//支付信息
			postOrderPayInfo() {
				$orderPayInfo({ id: this.selectItem.id }).then((res) => {
					this.orderPrice = res.data;
					this.orderRequireDetails = Object.keys(res.data.info.order_require_details).map(
						(item) => {
							return {
								name: item,
								value: res.data.info.order_require_details[item].join(','),
							};
						}
					);
				});
			},
			//方案 10审核 11 验收员
			postPalnAudit() {
				let params = {
					id: this.selectItem.id,
					type: this.auditRadio,
				};
				if (this.auditRadio == 2) {
					params.remark = this.auditValue;
					if (this.auditValue.length == 0) {
						this.$message({
							showClose: true,
							message: '请先输入不通过原因',
							type: 'warning',
						});
						return;
					}
				}
				switch (this.popType) {
					case 10:
						$palnAudit(params).then((res) => {
							this.closePop('审核操作成功');
						});
						break;
					case 11:
						$palnAcceptance(params).then((res) => {
							this.closePop('验收操作成功');
						});
						break;
				}
			},
			//报价列表
			postQuotedPrice() {
				let params = {
					id: this.selectItem.id,
					day_time: this.deliveryTime,
				};
				$quotedPrice(params).then((res) => {
					this.closePop('报价成功');
				});
			},
			//订单报价
			getReportPrice() {
				$reportPrice({ id: this.selectItem.id }).then((res) => {
					this.orderPrice.info = res.data;

					this.orderRequireDetails = Object.keys(res.data.order_require_details).map((item) => {
						return {
							name: item,
							value: res.data.order_require_details[item].join(','),
						};
					});
				});
			},
			// 获取方案列表
			getPlanList() {
				$planList({ id: this.selectItem.id }).then((res) => {
					this.planList = res.data;
				});
			},
			//1分配主責设计师  7分配协助设计师
			allocationDesign() {
				let params = {
					id: this.selectItem.id,
					design_id: this.designItem.id,
				};
				if (this.popType == 1) {
					$allocationDesign(params).then((res) => {
						this.closePop('分配成功');
					});
				} else {
					$allocationChildDesig(params).then((res) => {
						this.closePop('分配成功');
					});
				}
			},
			//取消订单 拒绝协助
			cancelOrder() {
				let params = { id: this.selectItem.id, type: this.cancelRadio };
				if (this.cancelRadio == 5) {
					params.remark = this.cancelValue;
				}

				switch (this.popType) {
					case 8:
						$cancelOrder(params).then((res) => {
							this.closePop('取消成功');
						});
						break;
					case 2:
						$refusedAllocation(params).then((res) => {
							this.closePop('已拒绝分配');
						});
						break;
					case 13:
						$childRefusedAllocation(params).then((res) => {
							this.closePop('已拒绝协助');
						});
						break;
					case 14:
						$afterSales(params).then((res) => {
							this.closePop('撤单申请已提交，请耐心等待撤单审核');
						});
						break;
				}
			},

			//获取赋值选中的值
			setSelectItem(selectItem) {
				this.selectItem = selectItem;
			},
			//确定报价
			postFirmPrice() {
				this.$confirm('确认《' + this.selectItem.order_pro_name + '》项目的报价', '确认报价', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
				})
					.then(() => {
						$firmPrice({ id: this.selectItem.id }).then((res) => {
							this.closePop('确认成功');
						});
					})
					.catch(() => {});
			},
			//继续设计
			continueDesign() {
				let that = this;
				this.$confirm('确认《' + that.selectItem.order_pro_name + '》项目继续设计', '继续设计', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
				})
					.then(() => {
						$refundRefusedConfirm({ id: that.selectItem.id }).then((res) => {
							that.closePop('确认成功');
						});
					})
					.catch(() => {});
			},
			//申请协助
			postRrequestAssist() {
				this.$confirm('申请协助《' + this.selectItem.order_pro_name + '》项目', '申请协助', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
				})
					.then(() => {
						$requestAssist({ id: this.selectItem.id }).then((res) => {
							this.closePop('协助申请已提交');
						});
					})
					.catch(() => {});
			},
			//接受 1分配 2协助
			agreeAllocation(num) {
				this.$confirm('确定接受《' + this.selectItem.order_pro_name + '》项目', '接受分配', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
				})
					.then(() => {
						if (num == 1) {
							$agreeAllocation({ id: this.selectItem.id }).then((res) => {
								this.closePop('接受分配');
							});
						} else {
							$childAgreeAllocation({ id: this.selectItem.id }).then((res) => {
								this.closePop('接受协助');
							});
						}
					})
					.catch(() => {});
			},
			//选择设计师
			selectDesingn(selection, row) {
				this.multipleSelection = row;
				// 清空所有选中
				this.$refs.designTable.clearSelection();
				if (row) {
					// 确保更新
					this.$nextTick(() => {
						// 选中当前
						this.$refs.designTable.toggleRowSelection(row, true);
						this.designItem = row;
					});
				}
				// 返回数据给父组件
				this.$emit('selection', row);
			},
			designPagingChange(page) {
				if (page == this.designPaging.page) return;
				this.designPaging.page = page;
				this.getOrderDesignList(this.popType);
			},
			//设计师列表
			getOrderDesignList(num, page) {
				this.designPaging.id = this.selectItem.id;
				if (page == 1) {
					this.designPaging.page = 1;
				}
				if (num == 7) {
					this.designPaging.main = 0;
				}
				if (num == 1) {
					this.designPaging.main = 1;
				}
				this.designPaging.search = this.designerSearchValue;
				$orderDesignList(this.designPaging)
					.then((res) => {
						this.designList = res.data;
						this.$parent.popType = num;
					})
					.catch();
			},
			//单选
			handleSelectionChange(selection, row) {
				this.multipleSelection = row;
				// 清空所有选中
				this.$refs.singleTable.clearSelection();
				if (row) {
					// 确保更新
					this.$nextTick(() => {
						// 选中当前
						this.$refs.singleTable.toggleRowSelection(row, true);
					});
				}
				// 返回数据给父组件
				this.$emit('selection', row);
			},
			//关闭弹窗，重置数据
			closePop(content) {
				if (content) {
					this.$message({ showClose: true, message: content, type: 'success' });
				}
				let params = {
					type: 1, //1关闭窗口 1 重置数据
					popType: 0,
				};
				this.deliveryTimeForm.deliveryTime = ''; // 重置交付时间
				this.cancelValue = '';
				this.auditValue = '';
				this.$emit('changParams', params);
				try {
					this.$emit('getDetails', {});
				} catch (error) {
					console.log(error);
				}
			},
			//关闭窗口
			handleCloseDetail() {
				let fileLoadding = this.checkFileLoading();
				if (fileLoadding) {
					return;
				}
				let params = {
					type: 0, //0关闭窗口 1 重置数据
					popType: 0,
				};
				this.secondPopType = 0;
				this.$emit('changParams', params);

				this.deliveryTimeForm.deliveryTime = ''; // 重置交付时间
				this.cancelValue = '';
				this.auditValue = '';
			},
			// 检测是否有 文件正在上传
			checkFileLoading() {
				let checkOver = false;
				if (this.popType == 5 || this.popType == 9) {
					this.planList.forEach((item) => {
						if (item.downing && item.downing == 'loading') {
							checkOver = true;
							this.$message({
								showClose: true,
								message: `${item.file_name}文件正在上传,请勿操作`,
								type: 'warning',
							});
						}
					});
				}

				return checkOver;
			},

			getFile(val, valList) {
				// console.log(val);
				/**
				 * 单文件上传
				 */
				// 后缀名
				let lastSuffix = val.name.getSuffix();
				let allow = true;
				val.progress = 0;
				val.upping = false;
				let em_id = guid();
				let file_suffix = val.name.getSuffix();

				if (this.suffix_text.indexOf(val.name.getSuffix()) == -1) {
					allow = false;
					this.$message.error(`不支持上传${val.name.getSuffix()}格式的文件`);
					return;
				}

				if (val.size <= 50) {
					this.$message({
						showClose: true,
						message: '文件大小不能小于50字节',
						type: 'error',
					});

					return;
				}

				if (
					this.planList.find((item) => {
						return item.file_name == val.name || item.file_name + item.file_exit == val.name;
					})
				) {
					this.$message.error(`已有同名文件`);
					return;
				}

				// 文件大于1G 不让上传
				if (val.size > 1024 ** 3) {
					this.$message.error(`单个文件过大，请分多成多个文件上传`);
					return;
				}

				this.planList.push({
					em: em_id,
					file_exit: file_suffix, //.txt,
					file_name: val.name.replace('.' + val.name.getSuffix(), ''),
					url: val.raw,
					percentage: 0,
					todo: '已上传',
					downing: 'loading',
				});

				// const loading = this.$loading({
				//   lock: true,
				//   text: `正在上传${file.name.split(".")[0]}`,
				//   spinner: "el-icon-loading",
				//   background: "rgba(0, 0, 0, 0.7)",
				// });

				// 开始分片上传
				this.uploadFileSpilt(val.raw, 1024 * 1024 * 10, em_id, (ing, i, total) => {
					let complete = ((100 / total) * (i - 1 + ing.loaded / ing.total)).toFixed(1);
					// 实时监听 上传进度 渲染至当前上传文件项
					this.planList.forEach((item) => {
						if (item.em == em_id) {
							if (complete == 100) {
								complete = 99;
								item.todo = '整合中';
							}
							item.percentage = Number(complete);
						}
					});
				}).then((res) => {
					// 分片上传完
					if (res && res.code == 200) {
						// 向订单添加已上传的文件信息
						$uploadPlan({
							id: this.selectItem.id,
							name: res.data.file_name,
							new_name: res.data.file_new_name,
							size: res.data.size,
							url: res.data.url,
							suffix: res.data.suffix,
							sort: 1,
						}).then((res) => {
							if (res.code == 200) {
								// 添加完成 更新 显示
								this.planList.forEach((item) => {
									if (item.em == em_id) {
										item.percentage = 100;
										item.todo = '已上传';
										item.downing = 'success';
									}
								});
								// 刷新 上传文件列表
								$planList({ id: this.selectItem.id }).then((res) => {
									let lists = [...this.planList];
									let updating_list = [];
									lists.forEach((item) => {
										if (item.downing && item.downing == 'loading') {
											updating_list.push(item);
										}
									});
									this.planList = [...res.data, ...updating_list];
								});

								this.$message({
									showClose: true,
									message: '添加成功',
									type: 'success',
								});
							}
						});
					} else {
						this.planList.forEach((item) => {
							if (item.em == em_id) {
								item.percentage = 100;
								item.todo = '上传失败';
								item.downing = 'success';
							}
						});
					}
				});
			},
			// 分片上传
			async uploadFileSpilt(file, sliceLength = 1024 * 1024 * 10, turn, uploadCallback) {
				//大小分界值
				let cutoff_value = 1024 * 1024 * 20;
				let uploadOn = await $uploadOnlySplitOn({
					file_name: file.name,
					size: file.size, // 文件总大小
					suffix: file.name.getSuffix(),
				});
				if (file.size <= cutoff_value) {
					sliceLength = file.size;
				}
				// 使用进一法，来确定分片的个数
				let total_number = Math.ceil(file.size / sliceLength);
				// 分片的初始位置
				let start = 0;
				// 分片的结束位置
				let end = sliceLength;
				// 这里为promise.all方法准备一个数组
				let requset_file = null;

				for (let i = 1; i <= total_number; i++) {
					// 这里开始分片，并且把每一个分片上传到服务器
					// File{}
					//[0,0,1,0,1,2,3,4,5,5,2]
					let blob = file.slice(start, end); // 得到一个分片
					let formData = await new FormData(); // 创建一个FormData对象，准备传送数据
					await formData.append('file', blob); // formData
					await formData.append('uploadId', uploadOn.data.uploadId); // 同时为这个分片设置一个名称，其中的i帮助后端进行排序处理
					// formData组装好之后，调用pro()函数，返回一个promise对象，并把它放入parr数组中，方便后面的promise.all方法使用
					await formData.append('OSS_SEEK_TO', start);
					await formData.append('OSS_LENGTH', end);
					await formData.append('batch', i);
					if (i == total_number) {
						await formData.append('isuploadEnd', true);
					}
					start = end; // 调整下一个分片的起始位置
					end = start + sliceLength; // 调整下一个分片的结束位置
					if (end > file.size) {
						end = file.size; // 这里对最后的一个分片结束位置进行调整
					}

					// 打印 上传 formData数据
					// for (var value of formData.values()) {
					//   console.log(value);
					// }
					try {
						// 处理 并发问题 以及 传输顺序
						let result = await $uploadOnlySplitUpload({
							formData,
							onUploadProgress: (progressEvent) => {
								uploadCallback(progressEvent, i, total_number);
							},
						});

						result.dev_name = file.name;
						if (typeof result == 'object' && i == total_number && result.code == 200) {
							requset_file = result;
						}
					} catch (error) {}
				}
				return new Promise((resolve, reject) => {
					resolve(requset_file);
				});
			},

			goDownload() {
				if (this.planList.length > 0) {
					let list = this.planList.map((item) => {
						item.size = item.file_size;
						return item;
					});
					this.$downLoadZip(this.selectItem.order_pro_name, list, 'url', 'file_name', 'file_exit');
					// this.$refs.downzip.onDownload(
					//   this.selectItem.order_pro_name,
					//   this.planList
					// );
				}

				// for (let i = 0; i < this.planList.length; i++) {
				//   this.downloadItem(this.planList[i]);

				//   // window.location.href = this.planList[i].url;
				// }
				// this.$message.success('下载成功!')
			},
			//下载文件
			downloadItem(item) {
				//下载文件
				// window.open(item.url, "top");
				// let iframe = document.createElement("IFRAME");
				// iframe.style.display = "none";
				// iframe.style.height = 0;
				// iframe.setAttribute("src", item.url);
				// document.body.appendChild(iframe);
				// setTimeout(() => {
				//   iframe.parentNode.removeChild(iframe);
				//   iframe = null;
				// }, 200);
				let a = document.createElement('a');
				a.href = item.url;
				a.download = item.url;
				a.target = '_blank';
				a.click();
				// window.location.href = item.url;
				// console.log(item, "12312", item.file_name + item.file_exit);
				// var x = new XMLHttpRequest();
				// x.open("GET", item.url, true);
				// x.responseType = "blob";
				// x.onload = function (e) {
				//   var url = window.URL.createObjectURL(x.response);
				//   var a = document.createElement("a");
				//   a.href = url;
				//   a.download = item.file_name + item.file_exit; //下载后的文件名
				//   a.click();
				// };
				// x.send();
			},
			// 点击修改项目信息
			onBindChangeProjectInfo() {
				this.secondPopType = 2;
				const loading = this.$loading({
					lock: true,
					text: '请稍等',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)',
				});
				this.projectInfoLoading = true;
				$place_orderBusiness_type({})
					.then((res) => {
						if (res) {
							this.businessClassification = res.data;
							// this.ruleForm.order_business = res.data[0].id;
							// this.businessSubclass = res.data[0].children;
							// this.ruleForm.order_child_business = res.data[0].children[0].id;
						}
						// return $placeOrderRelation_project({});
						return $relationProjectEdit({ id: this.selectItem.id });
					})
					.then((res) => {
						if (res) {
							this.assoItemsAndSpecPro = res.data;
						}

						return $placeOrderPage({
							id: this.selectItem.id,
							is_crm: this.selectItem.crm_order_type,
							project_level: this.selectItem.crm_project_level,
							project_type: this.selectItem.crm_project_type,
						});
					})
					.then((res) => {
						if (res) {
							this.serveForm.solutionService = [];
							this.serveForm.outboundService = [];
							if (res.data.order_info) {
								this.getDraftOrder_info(res.data.order_info);
							}
							this.demandServiceList = {
								...res.data,
								fafw: this.selectItem.crm_order_type == 1 ? res.data.crm_fafw || [] : res.data.fafw,
								wcfw: this.selectItem.crm_order_type == 1 ? res.data.crm_wcfw || [] : res.data.wcfw,
							};
							let lael_name_program = {};
							this.demandServiceList.fafw.forEach((item, index) => {
								let radioGroupSelectedVal;
								if (this.inputTypeId[item.id]) {
									if (this.radioGroupSpecialintroduce.indexOf(item.id) != -1) {
										for (let i = 0; i < item.child.length; i++) {
											if (item.child[i].select == 1) {
												radioGroupSelectedVal = item.child[i].id;
												break;
											}
										}
									}

									let radioGroup;
									if (radioGroupSelectedVal && radioGroupSelectedVal > 0) {
										radioGroup = radioGroupSelectedVal;
									} else {
										radioGroup = '';
									}

									this.$set(this.$data, this.inputTypeId[item.id].keyValuePair, {
										...item,
										radioGroup,
										checkbox: [],
									});
								}

								lael_name_program[`${item.id}`] = item.name;
								if (item.select == 1) {
									this.changeServiceSelect(1, item);
								}
							});
							this.demandServiceList.wcfw.forEach((item, index) => {
								let radioGroupSelectedVal;
								if (this.inputTypeId[item.id]) {
									if (this.radioGroupSpecialintroduce.indexOf(item.id) != -1) {
										for (let i = 0; i < item.child.length; i++) {
											if (item.child[i].select == 1) {
												radioGroupSelectedVal = item.child[i].id;
												break;
											}
										}
									}

									let radioGroup;
									if (radioGroupSelectedVal && radioGroupSelectedVal > 0) {
										radioGroup = radioGroupSelectedVal;
									} else {
										radioGroup = '';
									}

									this.$set(this.$data, this.inputTypeId[item.id].keyValuePair, {
										...item,
										radioGroup,
										checkbox: [],
									});
								}
								lael_name_program[`${item.id}`] = item.name;
								if (item.select == 1) {
									this.changeServiceSelect(1, item);
								}
							});
						}
						loading.close();
						this.projectInfoLoading = false;
					})
					.catch((err) => {
						loading.close();
					});
			},
			changeOrderProArea(val) {
				if (val > 100000) {
					this.$message({
						showClose: true,
						message: '设计面积大于十万平方米，请联系设计岛客服单独报价。',
						type: 'warning',
					});
				}

				if (val) {
					this.calculateThePrice();
				}
			},
			// 更改 相关项目
			changeSelectedOrderBindId(val) {
				if (val) {
					let priceList = [...this.serveForm.solutionService, ...this.serveForm.outboundService];
					if (priceList.length > 0) {
						this.calculateThePrice();
					}
				}
			},
			// 抽取 草稿的订单基本信息
			getDraftOrder_info(data) {
				let {
					order_apply_name,
					order_business,
					order_child_business,
					order_dian_address,
					order_dian_time,
					order_require_file,
					order_email,
					order_is_dian,
					order_phone,
					order_pro_area,
					order_pro_name,
					order_pro_remark,
					order_bind_id,
					order_assign_id,
				} = data;
				// 姓名
				this.ruleForm.order_apply_name = order_apply_name;
				// 项目业态 住宅类型
				this.ruleForm.order_business = '';
				this.ruleForm.order_child_business = '';
				let is_order_business;
				if (order_business) {
					is_order_business = this.businessClassification.find((item) => {
						return item.id == order_business;
					});
					if (is_order_business) {
						this.changeBusinessClass(order_business);
						this.ruleForm.order_business = Number(order_business);

						// 项目业态 建筑类型
						this.ruleForm.order_child_business = Number(order_child_business);
						if (order_child_business) {
							this.changeBusinessSubclass(order_business);
						}
					}
				}

				// 邮箱
				this.ruleForm.order_email = order_email;
				// 相关项目
				this.ruleForm.order_bind_id = order_bind_id ? String(order_bind_id) : '';
				// 指定产品
				this.ruleForm.order_assign_pro = order_assign_id || '';
				// 手机
				this.ruleForm.order_phone = order_phone;
				// 设计面积
				this.ruleForm.order_pro_area = order_pro_area;
				// 项目名称
				this.ruleForm.order_pro_name = order_pro_name;
				// 备注
				this.ruleForm.order_pro_remark = order_pro_remark;
				// 外出地址
				this.order_dian_address = order_dian_address;
				// 外出时间
				this.order_dian_time = order_dian_time;
				//       if (order_require_file) {
				//   this.$data.fileList = order_require_file.map((item) => {
				//     item.upping = true;
				//     item.progress = 100;
				//     return item;
				//   });
				// }
				this.$forceUpdate();
			},
			// 更改 业态主类
			changeBusinessClass(val) {
				if (val) {
					// 查找
					let result = this.businessClassification.find(function (item) {
						return item.id == val;
					});
					// 子类赋值
					this.businessSubclass = result.children;
					this.ruleForm.order_child_business = '';
				} else {
					this.businessSubclass = [];
				}
			},
			// 更改 业态子类
			changeBusinessSubclass(val) {
				if (val) {
					let priceList = [...this.serveForm.solutionService, ...this.serveForm.outboundService];
					if (priceList.length > 0) {
						this.calculateThePrice();
					}
				} else {
					this.estimatedAmount = {};
				}
			},
			// 关闭 需求明细
			closeOrOpenFixedCheckDetails() {
				this.showCheckDetails = !this.showCheckDetails;
			},
			// 选择 需求服务
			async changeServiceSelect(val, data) {
				// 选择 方案服务（2） 或者 外出服务（3）
				let { solutionService, outboundService } = this.serveForm;
				if (val == 1) {
					if (data.child.length == 1) {
						data.child[0].select = 1;
					}
					this.serveForm_id.push(`${data.id}`);
					// 选中 导入
					switch (data.service_type) {
						case '2':
							this.serveForm.solutionService.push(data);
							break;
						case '3':
							this.serveForm.outboundService.push(data);
							break;
					}
				} else {
					this.serveForm_id.splice(this.serveForm_id.indexOf(`${data.id}`), 1);
					// 不选 导出
					let len;
					switch (data.service_type) {
						case '2':
							len = solutionService.length;
							// 查找
							for (let i = 0; i < len; i++) {
								if (solutionService[i].id == data.id) {
									this.serveForm.solutionService.splice(i, 1);
									break;
								}
							}
							// 取出

							break;
						case '3':
							len = outboundService.length;
							// 查找
							for (let i = 0; i < len; i++) {
								if (outboundService[i].id == data.id) {
									this.serveForm.outboundService.splice(i, 1);
									break;
								}
							}
							break;
					}
				}
				this.selecedCheckDetails = [];
				await this.calculateThePrice();
				// this.getCheckDetailTable();
				this.repetFilter();
				this.$forceUpdate();
			},
			// 单独输入框
			enterAloneCase(ev, data) {
				if (!ev || ev <= 0) {
					this.$message({
						showClose: true,
						message: `${data.value.child[0].name}不能为空，不能小于1`,
						type: 'warning',
					});
					data.value.child[0].dw_num = 1;
				} else if (ev > 100) {
					this.$message({
						showClose: true,
						message: `${data.value.child[0].name}不能大于100`,
						type: 'warning',
					});
					data.value.child[0].dw_num = 1;
				}
				data.value.child[0].select = 1;
				// 方案或 外出 更改
				this.correspondingIntroduction(ev, data);
				// 价格计算
				this.calculateThePrice();
				this.$forceUpdate();
			},
			// 单选按钮
			chageRadioCase(ev, data) {
				data.value.child.forEach((item) => {
					if (item.id == data.value.radioGroup) {
						item.select = 1;
					} else {
						item.select = 0;
					}
				});
				// 方案或 外出 更改
				this.correspondingIntroduction(ev, data);
				// console.log("单选按钮", ev, data);
				// 价格计算
				this.calculateThePrice();
				this.$forceUpdate();
			},
			// 单选按钮 输入框
			chageRadioInput(ev, data) {
				if (!ev || ev <= 0) {
					this.$message({
						showClose: true,
						message: `${data.value.child[data.index].name}不能为空，不能小于1`,
						type: 'warning',
					});
					data.value.child[data.index].dw_num = 1;
				} else if (ev > 100) {
					this.$message({
						showClose: true,
						message: `${data.value.child[data.index].name}不能大于100`,
						type: 'warning',
					});
					data.value.child[data.index].dw_num = 1;
				}
				this.correspondingIntroduction(ev, data);
				this.calculateThePrice();
				this.$forceUpdate();
			},
			// 多选按钮
			changeCheckBoxCase(ev, data) {
				// console.log("多选按钮", ev, data);
				this.correspondingIntroduction(ev, data);
				this.calculateThePrice();
				this.$forceUpdate();
			},
			// 多选 按钮 输入框
			changeCheckBoxInput(ev, data) {
				if (!ev || ev <= 0) {
					this.$message({
						showClose: true,
						message: `${data.value.child[data.index].name}不能为空，不能小于1`,
						type: 'warning',
					});
					data.value.child[data.index].dw_num = 1;
				} else if (ev > 100) {
					this.$message({
						showClose: true,
						message: `${data.value.child[data.index].name}不能大于100`,
						type: 'warning',
					});
					data.value.child[data.index].dw_num = 1;
				}
				this.correspondingIntroduction(ev, data);
				this.calculateThePrice();
				this.$forceUpdate();
			},
			// 对应引入
			correspondingIntroduction(ev, data) {
				let { solutionService, outboundService } = this.$data.serveForm;
				let len = solutionService.length;
				let len_1 = outboundService.length;

				switch (data.value.service_type) {
					case '2':
						for (let i = 0; i < len; i++) {
							if (solutionService[i].id == data.value.id) {
								this.serveForm.solutionService[i] = data.value;
								break;
							}
						}
						break;
					case '3':
						for (let i = 0; i < len_1; i++) {
							if (outboundService[i].id == data.value.id) {
								this.serveForm.outboundService[i] = data.value;
								break;
							}
						}
						break;
				}
			},
			// 计算价格
			calculateThePrice() {
				try {
					let order_require_design = this.integrationRequirements();
					return order_require_design;
					// let { ruleForm } = this.$data;
					// this.$refs["ruleForm"].validate((valid) => {
					//   if (valid) {

					//     // if (order_require_design.length == 0) {
					//     //   this.estimatedAmount = {};
					//     //   return;
					//     // }
					//     // let parmas = {
					//     //   order_area: ruleForm.order_pro_area,
					//     //   order_business_id: ruleForm.order_business,
					//     //   order_child_business_id: ruleForm.order_child_business,
					//     //   order_bind_id: ruleForm.order_bind_id || 0,
					//     //   order_require_design,
					//     // };
					//     // $place_orderCalculatePrice(parmas).then((res) => {
					//     //   if (res) {
					//     //     this.estimatedAmount = res.data;
					//     //   }
					//     // });
					//   } else {
					//     return false;
					//   }
					// });
				} catch (err) {
					console.log(err);
				}
			},
			// 整合需求
			integrationRequirements() {
				let { serveForm } = this.$data;
				let complexList = [...serveForm.solutionService, ...serveForm.outboundService];
				let order_require_design = [];
				let selectedData = [];
				complexList
					.map((item) => {
						// item.child = item.child.map((key) => {
						//   key.relation_id = item.service_type;
						//   return key;
						// });
						return item.child;
					})
					.flat()
					.forEach((item) => {
						let { id, relation_id, dw_num,name } = item;
						if (item.select == 1) {
							selectedData.push(item);
							order_require_design.push({
								id,
								relation_id,
								dw_num,
								option:name
							});
						}
					});
				this.selecedCheckDetails = selectedData;
				this.order_require_design = order_require_design;
				return order_require_design;
			},
			// 确认编辑
			async submitForm(formName) {
				let { outboundService, solutionService } = this.serveForm;
				let { order_dian_address, order_dian_time } = this.$data;
				this.$refs[formName].validate(async (valid) => {
					if (valid) {
						if (outboundService.length > 0) {
							if (!order_dian_address) {
								this.$message.error('请输入外出地址');
								return;
							}
							if (!order_dian_time) {
								this.$message.error('请输入外出时间');
								return;
							}
						} else if (outboundService.length == 0) {
							this.$data.order_dian_address = '';
							this.$data.order_dian_time = '';
						}
						// console.log(outboundService.length > 0 || solutionService.length > 0);
						// console.log(this.order_require_design.length);
						if (outboundService.length > 0 || solutionService.length > 0) {
							if (this.order_require_design.length <= 0) {
								this.$message.error('请完善需求服务信息');
								return;
							}
						}

						let complexList = [...solutionService, ...outboundService];
						let len = complexList.length;
						for (let i = 0; i < len; i++) {
							let isSelect = complexList[i].child.find((item) => {
								return item.select;
							});

							if (!isSelect) {
								this.$message.error(`请选择${complexList[i].name}需求！`);
								return [];
							}
						}

						this.$confirm('信息是否确认无误,是否确认编辑', '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning',
						})
							.then(async () => {
								let parmas = await this.getParmasData();
								parmas.id = this.selectItem.id;
								$placeOrderEdit(parmas).then((res) => {
									if (res) {
										this.$alert('编辑成功', '系统提示', {
											confirmButtonText: '确定',
											callback: (action) => {
												// this.$router.go(-1);
												this.secondPopType = 0;
												this.getReportPrice();
												try {
													this.$emit('getDetails', {});
												} catch (error) {
													console.log(error);
												}
											},
										});
									}
								});
							})
							.catch(() => {});
					} else {
						return false;
					}
				});
			},

			// 获取 编辑订单参数
			async getParmasData() {
				let { ruleForm, order_dian_time, order_dian_address, order_require_design } = this.$data;
				// console.log(this.$data);
				let {
					order_child_business,
					order_business,
					order_pro_area,
					order_bind_id,
					order_pro_remark,
					order_pro_name,
					order_assign_pro,
					// order_apply_name,
					// order_phone,
				} = ruleForm;

				let parmas = {};
				// let order_require_file = await this.uploadImage();
				// 外出时间
				parmas.order_dian_time = order_dian_time;
				// 外出地址
				parmas.order_dian_address = order_dian_address;
				//设计 需求
				// if (order_require_design.length > 0) {
				parmas.order_require_design = order_require_design;
				// }
				// 业态 子类
				// if (order_child_business) {
				parmas.order_child_business_id = order_child_business;
				// }
				// 业态 大类
				// if (order_business) {
				parmas.order_business_id = order_business;
				// }
				// 备注
				// if (order_pro_remark) {
				parmas.order_pro_remark = order_pro_remark;
				// }
				// 关联订单
				// if (order_bind_id) {
				parmas.order_bind_id = order_bind_id;
				// }
				// 设计面积
				// if (order_pro_area) {
				parmas.order_pro_area = order_pro_area;
				// }
				// 项目名称
				// if (order_pro_name) {
				parmas.order_pro_name = order_pro_name;
				// }
				// 申请人姓名
				// if (order_apply_name) {
				// parmas.order_apply_name = order_apply_name;
				// }
				// 手机号
				// if (order_phone) {
				// parmas.order_phone = order_phone;
				// }
				// 邮箱
				// if (ruleForm.order_email) {
				//   parmas.order_email = ruleForm.order_email;
				// }
				// 指定产品
				if (order_assign_pro) {
					parmas.order_assign_id = ruleForm.order_assign_pro;
				}
				// 附件
				// if (order_require_file.length > 0) {
				//   parmas.order_require_file = JSON.stringify(order_require_file);
				// }

				return parmas;
			},

			// 是否 显示 提示 ‘请选择需求数量’
			repetFilter() {
				let { un_showNeedTodoList, serveForm_id } = this.$data;
				let filterList = [];
				if (serveForm_id.length > 0) {
					serveForm_id.forEach((item) => {
						let result = un_showNeedTodoList.filter((val) => {
							return val == item;
						});
						filterList.push(...result);
					});

					if (serveForm_id.length > filterList.length) {
						this.un_showNeedTodo = true;
					} else {
						this.un_showNeedTodo = false;
					}
				} else {
					this.un_showNeedTodo = false;
				}
			},
			onBeforeUpload(val) {
				// console.log("onBeforeUpload", val);
			},
		},
		destroyed() {
			clearInterval(this.endTime);
		},
	};
	// JS生成唯一id方式介绍（UUID和NanoID）
	function guid() {
		return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
			var r = (Math.random() * 16) | 0,
				v = c == 'x' ? r : (r & 0x3) | 0x8;
			return v.toString(16);
		});
	}

	/**
	 *  防抖
	 * @param {Object} fn
	 * @param {Number} delay
	 * 调用 let XXX = delayDither((argv)=>{}, 600)
	 * XXX()
	 */
	function delayDither(delay = 600) {
		let timer = null;
		return function (fn) {
			if (timer) {
				clearTimeout(timer);
			}
			const _that = this;
			let argv = arguments;
			timer = setTimeout(function () {
				fn.apply(_that, argv);
			}, delay);
		};
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
	::v-deep .title-drawer {
		position: relative;
		box-sizing: border-box;
		padding: 0px 32px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		width: 100%;
		height: 54px;
		background: rgba(255, 255, 255, 1);
		box-shadow: 0px 1px 0px #e9e9e9;

		font-weight: bold;

		.title-text {
			font-size: 16px;
		}
		.close-title-drawer {
			cursor: pointer;
			width: 0.5rem;
			height: 0.5rem;
			display: flex;
			i {
				font-size: 0.5rem;
				font-weight: 600;
			}
		}
	}
	.apply-refund {
		background-color: rgba(230, 50, 65, 0.1);
		padding: 12px 24px 14px 32px;
		display: flex;

		img {
			width: 24px;
			height: 24px;
			margin-right: 12px;
		}
		span {
			font-size: 16px;

			font-weight: bold;
			line-height: 24px;
			color: #333333;
		}
	}
	.pop-cont-box {
		padding: 32px;
		h5 {
			font-size: 20px;

			font-weight: bold;
			line-height: 22px;
			color: #333333;
			margin-bottom: 24px;
		}
	}

	::v-deep .select-designer-box {
		.el-table__header-wrapper {
			background: rgba(250, 250, 250, 0.39);
		}
		.has-gutter {
			background: rgba(250, 250, 250, 0.39);
			.cell .el-checkbox {
				// 找到表头那一行，然后把里面的复选框隐藏掉
				display: none !important;
			}
		}
		.el-checkbox__input.is-checked .el-checkbox__inner {
			background-color: rgba(230, 50, 65, 1);
			border-color: rgba(230, 50, 65, 1);
		}
	}

	.line-block {
		width: 100%;
		height: 100px;
	}
	.designer-btn-box {
		width: 100%;
		display: flex;
		position: absolute;
		bottom: 0;
		border-top: 1px solid #e9e9e9;
		background-color: #fff;
		justify-content: flex-end;
		padding: 17px 0;
		z-index: 5;
	}
	.cancel-btn {
		cursor: pointer;
		padding: 6px 19px;
		background: rgba(255, 255, 255, 0.39);
		border: 1px solid #e9e9e9;
		border-radius: 4px;
		font-size: 14px;

		font-weight: 400;
		line-height: 22px;
		color: #333333;
		margin-right: 8px;
	}
	.sure-btn {
		cursor: pointer;
		padding: 6px 19px;
		background: rgba(230, 50, 65, 1);
		border-radius: 4px;
		font-size: 14px;

		font-weight: 400;
		line-height: 22px;
		color: #ffffff;
		margin-right: 32px;
	}
	::v-deep .refused-box {
		.el-radio__label,
		.el-radio {
			font-size: 16px;
		}
		.is-checked {
			.el-radio__inner {
				border-color: rgba(230, 50, 65, 1);
				background: #fff;
			}
			.el-radio__inner::after {
				width: 7px;
				height: 7px;
				border-radius: 100%;
				background-color: rgba(230, 50, 65, 1);
				content: '';
				position: absolute;
				left: 50%;
				top: 50%;
				transform: translate(-50%, -50%) scale(1);
				transition: transform 0.15s ease-in;
			}
			.el-radio__label {
				font-size: 16px;

				font-weight: 400;
				line-height: 22px;
				color: #333333;
			}
		}
	}
	.refused-title {
		font-size: 16px;

		font-weight: bold;
		line-height: 19px;
		color: #666666;
		margin: 38px 0 24px 0;
	}
	.refused-other-box {
		display: flex;
		justify-content: flex-start;
		margin-top: 17px;
		p {
			font-size: 16px;

			font-weight: 400;
			line-height: 22px;
			span {
				color: #e60000;
				margin: 0 20px 0 10px;
			}
		}
		textarea {
			width: calc(var(--proportion) * 400px);
			height: 120px;
			background: rgba(255, 255, 255, 0.39);
			border: 1px solid rgba(0, 0, 0, 0.14);
			opacity: 1;
			border-radius: 4px;
			padding: 10px 12px;

			font-size: 16px;
		}
	}
	// 订单报价
	.order-price {
		font-size: 14px;

		font-weight: 400;
		line-height: 22px;
		color: #333333;
		margin-bottom: 48px;
		span {
			font-size: 16px;

			font-weight: bold;
			line-height: 22px;
			color: #e60000;
		}
	}
	.order-infor-title {
		display: flex;
		justify-content: space-between;
		margin: 0 0 24px 0;
		span {
			font-size: 16px;

			font-weight: bold;
			line-height: 19px;
			color: #666666;
			opacity: 1;
		}
	}
	.infor-btn {
		cursor: pointer;
		display: flex;
		justify-content: flex-end;
		align-items: center;
		font-size: 16px;

		font-weight: 400;
		line-height: 19px;
		color: #e60000;
		img {
			width: 12px;
			height: 12px;
			margin-right: 8px;
		}
	}
	.infor-box {
		td {
			border: 1px solid #e9e9e9;
		}
		tr td:first-child {
			text-align: center;
			background-color: #fff;
			background: rgba(233, 233, 233, 1);
			box-shadow: -1px 0px 10px rgba(0, 0, 0, 0.1);
			font-size: 16px;

			font-weight: 400;
			line-height: 22px;
		}
		tr td:nth-child(2) {
			padding: 0 24px 12px;
			font-size: 16px;

			font-weight: 400;
			line-height: 22px;
			color: #333333;
		}
	}
	.project-infor {
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
		p {
			margin-top: 12px;
		}
	}
	.order-demand {
		p {
			margin-top: 12px;
		}
	}
	.order-note {
		margin-top: 12px;
	}
	.pay-time {
		font-size: 16px;

		font-weight: bold;
		line-height: 19px;
		color: #666666;
		margin: 32px 0 20px 0;
	}
	.order-time-box {
		display: flex;
		justify-content: flex-start;
		align-items: center;

		::v-deep {
			.el-form-item__content {
				width: calc(var(--proportion) * 320px);
				min-width: 180px;
			}
		}
		p {
			font-size: 16px;

			font-weight: 400;
			line-height: 22px;
			span {
				color: #e60000;
				margin: 0 20px 0 10px;
			}
		}
	}
	.order-input-box {
		display: flex;
		justify-content: space-between;
		width: calc(var(--proportion) * 400px);
		padding: 9px 12px;
		background: rgba(255, 255, 255, 0.39);
		border: 1px solid rgba(0, 0, 0, 0.149);
		opacity: 1;
		input {
			width: 85%;
			font-size: 16px;
			font-weight: 400;
			line-height: 22px;
		}
		span {
			font-size: 16px;

			font-weight: 400;
			line-height: 22px;
			color: #999999;
		}
	}

	// 二级弹窗
	.opera-pop-box {
		display: flex;
		justify-content: flex-end;
		align-items: center;
	}
	.opera-back {
		cursor: pointer;
		font-size: 16px;

		font-weight: 400;
		line-height: 22px;
		color: #333333;
		margin-right: 55px;

		i {
			font-size: 0.5rem;
			font-weight: 600;
			margin-right: 8px;
		}
	}
	.check-pay-btn {
		// width: 96px;
		// height: 32px;
		cursor: pointer;
		display: inline-block;
		padding: 6px 20px;
		background: rgba(230, 50, 65, 1);
		border-radius: 4px;
		font-size: 14px;

		font-weight: 400;
		line-height: 22px;
		color: #ffffff;
		margin-top: 32px;
	}
	// 支付页面

	.second-content-box {
		padding: 32px 22px;
	}
	.pay-info-box {
		display: flex;
		justify-content: flex-start;
	}
	.pay-code {
		width: 148px;
		height: 148px;
		margin-right: 24px;
	}
	.pay-amount {
		font-size: 16px;

		font-weight: 400;
		line-height: 22px;
		color: #333333;
		span {
			font-size: 24px;

			font-weight: bold;
			line-height: 22px;
			color: #e60000;
		}
	}
	.pay-intro {
		font-size: 14px;

		font-weight: 400;
		line-height: 22px;
		color: #333333;
		margin: 8px 0 39px 0;
	}
	.pay-type {
		img {
			width: 20px;
			height: 20px;
			margin-right: 8px;
		}

		font-size: 14px;

		font-weight: 400;
		line-height: 22px;
		color: #333333;
	}
	.pay-end-time {
		font-size: 14px;

		font-weight: 400;
		color: #999999;
		margin-top: 12px;
	}
	// 支付成功
	.pay-succes {
		display: flex;
		justify-content: flex-start;
		padding: 34px 32px;
		img {
			width: 48px;
			height: 48px;
			margin-right: 24px;
		}
		h5 {
			font-size: 20px;

			font-weight: bold;
			line-height: 22px;
			color: #333333;
			margin: 10px 0;
		}
		p {
			font-size: 16px;

			line-height: 22px;
			color: rgba(51, 51, 51, 1);
			margin-top: 16px;
			span {
				color: #e60000;
				font-weight: bold;
				margin-left: 8px;
			}
		}
	}
	// 上传方案
	.add-solution-box {
		padding: 34px 32px;
	}
	.choose-file-box {
		position: relative;
		font-size: 14px;

		font-weight: bold;
		line-height: 22px;
		color: #e60000;
		i {
			font-size: 12px;
			color: #e60000;
			margin-right: 5px;
			cursor: pointer;
		}
		span {
			cursor: pointer;
		}
		input {
			cursor: pointer;
			// display: none;
			opacity: 0;
			width: 150px;
			position: absolute;
			left: 0;
			top: 0;
		}
	}
	//添加方案
	::v-deep .add-plan-box {
		margin-top: 24px;
	}
	// 评价
	::v-deep .evaluation-box {
		padding: 32px;
		.el-icon-star-on:before {
			font-size: 20px;
		}
	}
	.evaluation-stars {
		display: flex;
		justify-content: flex-start;
		align-items: center;
		span {
			font-size: 16px;

			font-weight: 400;
			line-height: 22px;
			color: #333333;
			margin: 13px 0 0 32px;
		}
	}
	// 不通过原因
	.reason-failure {
		padding: 32px;
		border-bottom: 10px solid rgba(245, 245, 245, 1);
		h5 {
			font-size: 20px;

			font-weight: bold;
			line-height: 22px;
			color: #333333;
		}
	}
	.failure-content {
		display: flex;
		justify-content: flex-start;
		margin-top: 16px;
		img {
			width: 24px;
			height: 24px;
			margin-right: 12px;
		}
		h6 {
			font-size: 14px;

			font-weight: 400;
			line-height: 22px;
			color: #333333;
			margin-top: 10px;
		}
	}
	.check-infor {
		display: flex;
		justify-content: space-between;
		width: calc(var(--proportion) * 686px);
	}
	.check-type {
		font-size: 16px;

		font-weight: bold;
		line-height: 22px;
		color: #333333;
	}
	.check-time {
		font-size: 12px;

		font-weight: 400;
		line-height: 22px;
		color: #999999;
		span {
			margin-right: 32px;
		}
	}

	// 审核方案 验收方案

	.operate-play-box {
		padding: 32px;
	}
	.play-title-box {
		display: flex;
		justify-content: space-between;
		p {
			font-size: 20px;

			font-weight: bold;
			line-height: 22px;
			color: #333333;
		}
	}
	.download-play {
		cursor: pointer;
		padding: 6px 12px;
		background: rgba(230, 50, 65, 1);
		font-size: 14px;

		font-weight: 400;
		line-height: 22px;
		color: #ffffff;
		border-radius: 4px;
	}

	// 支付报价
	.pay-price-box {
		p {
			font-size: 16px;

			line-height: 22px;
			color: rgba(51, 51, 51, 1);
			margin-top: 16px;
			span {
				color: #e60000;
				font-weight: bold;
				margin-left: 8px;
			}
		}
	}
	.pay-price-intro {
		margin-top: 32px;
		font-size: 14px;

		font-weight: 400;
		line-height: 22px;
		color: #999999;
	}

	.order-list-page {
		display: flex;
		justify-content: end;
		margin-top: 30px;
	}
	::v-deep .cell {
		font-size: 16px;

		font-weight: 400;
		line-height: 22px;
	}
	.modify-the-form-title {
		padding-left: 10px;
		font-size: 20px;

		font-weight: bold;
		color: #333333;
	}
	.modify-the-form-info {
		margin-top: 12px;
		padding-left: 10px;
		padding-bottom: 12px;
		display: flex;
		justify-content: flex-start;
		flex-wrap: wrap;
	}
	.form-info-item {
		margin-right: 26px;
		margin-bottom: 14px;
		font-size: 14px;

		font-weight: 400;
		line-height: 22px;
		color: #333333;
		span {
			margin-left: 4px;
		}
	}
	.demo-ruleForm {
		.form-label.not {
			margin-right: 0px;
		}
		.form-label.right-margin.format-inline {
			::v-deep .el-form-item__content > div {
				margin-right: 10px;
			}
			::v-deep .el-form-item__content {
				display: flex;
			}
		}
		.form-label.right-margin {
			margin-right: calc(var(--proportion) * 22px);
		}
		.form-label {
			margin-right: calc(var(--proportion) * 32px);
		}
		.form-label {
			margin-bottom: 20px;
		}

		::v-deep .el-form-item__label::before {
			content: '' !important;
			margin-right: 0px;
		}
		::v-deep .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:after {
			content: '*';
			position: absolute;
			right: 7px;
			top: 50%;
			transform: translateY(-50%);
			color: #f56c6c;
		}
		::v-deep .el-form-item__label {
			position: relative;
			padding-right: 24px;
		}

		.adjacent-select {
			width: calc((var(--proportion) * (353px / 2)) - 5px);
		}
	}

	.info-title {
		position: relative;
		margin: 30px 0px;
		margin-bottom: 16px;
		font-size: 18px;

		font-weight: bold;
		color: #333333;
		.check-details {
			cursor: pointer;
			position: absolute;
			top: 50%;
			transform: translateY(-50%);
			right: 0px;
			font-size: 14px;

			font-weight: 400;
			color: #3094e0;
		}
	}

	.screen-two-form-lalbel {
		::v-deep .el-form-item__label {
			font-size: 16px !important;

			font-weight: bold;
			color: #666666;
		}
	}

	.screen-two-form-lalbel {
		::v-deep .el-checkbox {
			.el-checkbox__label {
				color: #606266;
				padding-left: 6px;
			}
		}

		::v-deep .el-form-item__content .el-checkbox-group {
			display: flex;
			flex-wrap: wrap;
			justify-content: space-between;
		}
		::v-deep .el-form-item__content {
			margin-left: 75px;
			// width: 700px;
		}
		::v-deep .el-checkbox__input.is-checked .el-checkbox__inner,
		::v-deep .el-checkbox__input.is-indeterminate .el-checkbox__inner {
			background-color: #e60000;
			border-color: #e60000;
		}
	}
	.form-title-screen-two {
		margin-bottom: 16px;
		font-size: 16px;

		font-weight: bold;
		color: #666666;
	}

	.form-screen-main {
		.form-label.not {
			margin-right: 0px;
		}
		.form-label.right-margin {
			margin-right: calc(var(--proportion) * 22px);
		}
		.form-label {
			margin-right: calc(var(--proportion) * 32px);
		}
		.form-label {
			margin-bottom: 20px;
		}

		::v-deep .el-checkbox {
			margin-right: 6px;
			.el-checkbox__label {
				color: #606266;
				padding-left: 6px;
			}
		}
		.checkbox-input-group {
			display: flex;
			align-items: center;
			flex-wrap: wrap;
			justify-content: flex-start;
		}
		.checkbox-input.bottom {
			margin-bottom: 20px;
		}
		.checkbox-input {
			margin-bottom: 10px;
			margin-right: 12px;
			display: flex;
			align-items: center;
		}
		::v-deep .el-checkbox__input.is-checked .el-checkbox__inner,
		::v-deep .el-checkbox__input.is-indeterminate .el-checkbox__inner {
			background-color: #e60000;
			border-color: #e60000;
		}
		::v-deep .el-form-item__label::before {
			content: '' !important;
			margin-right: 0px;
		}
		::v-deep .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:after {
			content: '*';
			position: absolute;
			right: 7px;
			top: 50%;
			transform: translateY(-50%);
			color: #f56c6c;
		}
		::v-deep .el-form-item__label {
			position: relative;
			padding-right: 24px;
		}
	}
	.form-shelf-height {
		min-height: 100vh;
	}

	.submit-form-order-edit {
		display: flex;
		justify-content: right;
	}
	.form-order-confirm {
		color: #fff;
		background: rgba(230, 50, 65, 1);
		border-radius: 4px;
	}
	.orderOperation {
		position: relative;
	}
	.percentage-width {
		display: inline-block;
		width: 50px;
	}
	::v-deep .list-item-search {
		width: 380px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		.el-input {
			width: 300px;
			height: 40px;
		}
	}
	.designer-input {
		margin-bottom: 10px;
	}

	// 输入框右边内容
	::v-deep {
		.el-input--suffix .el-input__inner {
			padding-right: 37px;
		}
		.el-input__suffix {
			right: 0px;
			padding-left: 12px;
			margin: 0 12px 0 0;
			color: #999999;
			font-size: 16px;
		}
	}

	.btn_box {
		cursor: pointer;
		color: #e60000;
		&:hover {
			text-decoration: underline;
		}
	}
	.upload-demo {
		.download-icon-hover {
			display: none;
		}

		span:active,
		span:hover {
			// background-color: #e60000 !important;
			color: #e60000;

			.download-icon {
				display: none;
			}
			.download-icon-hover {
				display: inline-block;
			}
		}
	}

	.p2 {
		font-size: 14px;
		font-family: PingFang SC;
		font-weight: 400;
		line-height: 22px;
		color: #333333;
		margin-top: 16px;
		.s1 {
			font-size: 16px;
			font-family: PingFang SC;
			font-weight: 400;
			line-height: 22px;
			color: #e60000;
		}
	}
	.input-illustrate {
		margin-top: 40px;
		display: flex;
		justify-content: flex-start;

		.title-illustrate {
			margin-right: 14px;
			font-size: 16px;
			font-weight: 400;
			line-height: 22px;
			color: #333333;
		}
		.illustrate-input {
			width: 400px;
			height: 120px;
			::v-deep {
				textarea {
					height: 120px;
				}
			}
		}
	}
	::v-deep {
		.image-slot {
			display: flex;
			justify-content: center;
			align-items: center;
			width: 148px;
			height: 148px;
			border: 1px solid #eee;
			margin-right: 24px;
		}
	}
</style>
